import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Comparable } from '../../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../../helpers/entities/trackable.interface';
import { ShGenericOverviewContainerComponent } from '../../../generic-overview/containers/generic-overview/generic-overview.container.component';
import { SearchPageSandbox } from '../../search-page.sandbox';
import { SearchPageContainerComponent } from '../search-page/search-page.container.component';

@Component({
    standalone: true,
    selector: 'sh-minimal-search-page',
    templateUrl: './minimal-search-page.container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SearchPageSandbox],
    imports: [CommonModule, ShGenericOverviewContainerComponent]
})
export class MinimalSearchPageContainerComponent<
    T extends Comparable & Trackable
> extends SearchPageContainerComponent<T> {}
